import '../Styles/Modal.css';

import { useEffect } from 'react';

export function SimpleModal({message, show, onModalClose}) {

    useEffect(() => {
        let modal_container = document.getElementById('smodal_container');
        if(show) {
            modal_container.classList.add('show');
        }
        else {
            closeModal();
        }
    }); 

    function closeModal() {
        let modal_container = document.getElementById('smodal_container');
        modal_container.classList.remove('show');
            if(onModalClose !== undefined)
                onModalClose();
    }

    return (
        <div className='modal-container' id='smodal_container'>
            <div className='modal'>
                <div className="modal-content">
                    <h1>
                    {message}
                    </h1>
                </div>
                
                    <div className="modal-button-center">
                        <button id="close-modal-button" className="Login-button" onClick={closeModal}><span>OK</span></button>
                    </div>
                                
            </div>
        </div>
    )
}
